import { render } from "./Column4.vue?vue&type=template&id=765994c1"
import script from "./Column4.vue?vue&type=script&lang=js"
export * from "./Column4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__